import { useGameOpt, useLobbyGame, useSessionUser } from "~/app";

export const useViewingPlayerOpt = () => {
  const playerIndex = useViewingPlayerIndexOpt();
  const { game } = useGameOpt() ?? {};
  if (!game || playerIndex === null) return null;

  const player = game.players[playerIndex];
  return player;
};

export const useViewingPlayerIndex = () => {
  const index = useViewingPlayerIndexOpt();
  if (index === null) {
    throw new Error("no player index");
  }
  return index;
};

export const useViewingPlayerIndexOpt = () => {
  const game = useLobbyGame();
  const sessionUser = useSessionUser();
  if (!game) {
    return null;
  }
  const index = game.users.findIndex((user) => user.id === sessionUser?.id);
  if (index === -1) {
    return null;
  }
  return index;
};
